'use strict';

// Debounce function based on the implementation from Underscore.js
export function debounce(func, wait, runAtStart = false, runAtEnd = true) {
	let timeout;

	return function() {
		let context = this, args = arguments;

		let later = function() {
			timeout = null;
			if (runAtEnd) {
				func.apply(context, args);
			}
		};

		let callNow = runAtStart && !timeout;

		window.clearTimeout(timeout);
		timeout = window.setTimeout(later, wait);

		if (callNow) {
			func.apply(context, args);
		}
	};
}